export const mapExtensionToType = (extension: string): string | null => {
  const typesMap = {
    video: ["mp4", "avi", "mov", "wmv", "m4v", "ogv", "ogg", "webm"],
    image: ["jpg", "jpeg", "tif", "tiff", "png", "psd", "gif", "bmp", "svg", "eps", "ai"],
    word: ["doc", "docx"],
    music: ["m4a", "mp3", "wav", "aif"],
    powerpoint: ["ppt", "pptx"],
    pdf: ["pdf"],
    excel: ["xls", "xlsx", "csv"],
    archive: ["zip", "rar", "7z"],
  };

  const normalizedExtension = extension.toLowerCase();
  return Object.entries(typesMap).find(([, extensions]) =>
    extensions.includes(normalizedExtension),
  )?.[0] ?? null;
};
